export default __webpack_public_path__ + "static/media/Wall_Window_8x4_04.256.2776477d.png";